"use strict";
var Observable_1 = require('../../Observable');
var windowCount_1 = require('../../operator/windowCount');
Observable_1.Observable.prototype.windowCount = windowCount_1.windowCount;
//# sourceMappingURL=windowCount.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/add/operator/windowCount.js
// module id = ./node_modules/rxjs/add/operator/windowCount.js
// module chunks = vendor